export enum OpenItemsActionEnum {
    InstantBilling = 'InstantBilling',
    LaterBilling = 'LaterBilling',
    NoMoreBilling = 'NoMoreBilling'
}